module.exports = __webpack_public_path__ + "img/God_is_Dead.08b315f0.jpg";